<template>
  <a-row>
    <a-row class="search-panel">
      <a-col :span="24">
        <ads-search-panel :keywords="keywords" :postdata="postdata" @inputchange="inputChange" @search="search"/>
      </a-col>
    </a-row>
    <a-row class="ads-list" v-if="tp_result.length > 0">
      <ads-list :list="tp_result" @qrcode="generateQrcode"/>
    </a-row>
    <a-modal v-if="devType === 'pc'" v-model="qrcodepanel" :key="refresh" :title="title" :footer="null" width="800px" :bodyStyle="{height: '620px'}">
      <ads-qrcode :news_id="news_id" :news_url="news_url" :ads_id="ads_id" :key="refresh" @change="closeModal" @cancel="closeModal"/>
    </a-modal>
    <a-modal v-else v-model="qrcodepanel" :key="refresh" :footer="null" width="800px" :bodyStyle="{height: '670px'}">
      <ads-qrcode :news_id="news_id" :news_url="news_url" :ads_id="ads_id" :key="refresh" @change="closeModal" @cancel="closeModal"/>
    </a-modal>
  </a-row>
</template>

<script>

import { AdsSearchPanel, AdsList, AdsQrcode} from '@/com/Ads'

export default {
  name: 'AdsSearch',
  props: {
    postdata: {
      type: Object,
      default: function() {
        return {}
      }
    },
    result: {
      type: Array,
      default: function() {
        return []
      }
    }
  },
  data() {
    return {
      devType: 'pc',
      tab: 'ads',
      keywords: "",
      tp_postdata: this.postdata,
      tp_result: this.result,
      qrcodepanel: false,
      news_id: "",
      news_url: "",
      ads_id: "",
      title: this.postdata.title,
      refresh: 1
    }
  },
  components: {
    AdsSearchPanel,
    AdsList,
    AdsQrcode
  },
  watch: {
    tp_postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
      this.keywords = newvalue.content
    },
    postdata(newvalue, oldvalue) {
      this.tp_postdata = newvalue
      this.keywords = newvalue.content
      this.title = newvalue.title
    },
    tp_result(newvalue, oldvalue) {
      this.tp_result = newvalue
    },
    result(newvalue, oldvalue) {
      this.tp_result = newvalue
    }
  },
  methods: {
    inputChange: function(content) {
      this.keywords = content
    },
    generateQrcode: function(news_id, url) {
      this.qrcodepanel = true
      this.news_id = news_id
      this.news_url = url
      this.ads_id = this.tp_postdata.ads_id
      this.refresh += 1
    },
    closeModal: function() {
      this.qrcodepanel = false
      this.news_id = ""
    },
    search: function(post, result, list) {
      this.tp_postdata = post;
      this.tp_result = result;
      this.tp_relationitem = list
      this.$emit('search', this.tp_postdata, this.tp_result)
    }
  },
  created() {
    let deviceWidth = document.body.clientWidth
    if (deviceWidth <= 500) {
      this.devType = 'mobile';
    }
    if (this.postdata.content) {
      this.keywords = this.postdata.content
    }
  }
}
</script>

<style scoped>
  .search-panel{
    border-right: 0px solid #d1d5da;
    border-left: 0px solid #d1d5da;
    border-bottom: 0px solid #d1d5da;
    border-radius: 0px 0px 3px 3px;
  }
  .ads-list {
    margin-top: 4px; 
    height: 100%;
    border-top: 1px solid #d1d5da;
    border-left: 1px solid #d1d5da;
    border-right: 1px solid #d1d5da;
    border-radius: 3px;
  }
  .pb8 {
    padding-bottom: 8px;
  }
  .card-border {
    border-top: 0px;
    border-bottom: 1px solid #e1e4e8;
    border-left: 0px;
    border-right: 0px;
  }
  .text-split {
    font-size: 14px;
    word-break:break-all;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
  }
  .mb4 {
    margin-bottom: 4px;
  }
</style>
